const angular = require('angular');

const { deliveryWizardComponentDefinition } = require('./delivery-wizard.component');
const { expressDeliveryAlertControllerDefinition } = require('./express-delivery-alert.component');

angular.module('wowApp.fulfilment')
    .component('wowDeliveryWizard', deliveryWizardComponentDefinition)
    .component('wowExpressDeliveryAlert', expressDeliveryAlertControllerDefinition);



// WEBPACK FOOTER //
// ./src/fulfilment/delivery/index.js